import React, { useState, useRef } from 'react';

import Image from '../../images/user-avatar-80.png';
import AlertModal from '../AlertModal'
import { createFeedback } from '../../graphql/mutations'
import { API } from 'aws-amplify';

function SettingsContentFeedback() {

  const [sync, setSync] = useState(false);
  const [alertModalState, setAlertModalState] = useState(null);
  const [message, setMessage] = useState('')
  const submitRef = useRef()

  async function submitFeedback(){
    if(message!=''){
      submitRef.current.setAttribute("disabled", true);
      const feedbackDetails = {  message: message }
      API.graphql({ query: createFeedback, variables: {input: feedbackDetails}}).then(createFeedbackResponse => {
        submitRef.current.removeAttribute("disabled");
        setAlertModalState({title: 'Thank You', message: 'Your feedback has been recorded and is greatly appreciated.'})
        setMessage('')
      }).catch( (createUserError) => {
        submitRef.current.removeAttribute("disabled");
        setAlertModalState({title: 'Oops', message: 'Didn\'t quite get that. Please try again.'})
      })
    }
  }

  return (
    <div className="flex-grow bg-gray-100">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        {/* Picture */}
        <div className="py-2 flex flex-col justify-center sm:py-2">
          <div className="py-3 sm:max-w-xl sm:mx-auto">
            <div className="bg-white min-w-1xl flex flex-col rounded-xl shadow-lg">
              <div className="px-12 pt-5">
                <h2 className="text-gray-800 text-2xl font-semibold text-center">We want to hear from you!</h2>
              </div>
              <div className=" w-full flex flex-col items-center">
                <div className="flex flex-col items-center py-6 space-y-3">
                  <span className="text-lg text-gray-800 px-12">What was useful and what wasn't?</span>
                  <span className="text-sm text-gray-600 px-12">(Your submission will be recorded anonymously.)</span>
                  <div className="flex space-x-3">
                    <svg className="w-12 h-12 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                    <svg className="w-12 h-12 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                    <svg className="w-12 h-12 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                    <svg className="w-12 h-12 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                    <svg className="w-12 h-12 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor">
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                    </svg>
                  </div>
                </div>
                <div className="w-3/4 flex flex-col">
                  <textarea rows="3"
                            className="p-4 text-gray-500 rounded-xl resize-none" placeholder={'Leave a message, if you want'}
                            onChange={event=>setMessage(event.target.value)} value={message}></textarea>
                  <button
                    className="py-3 my-8 text-lg bg-pink-500 rounded-xl text-white disabled:opacity-50"
                    onClick={()=> {
                      submitFeedback()
                    }} ref={submitRef}>Submit Feedback</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
    </div>
  );
}

export default SettingsContentFeedback;